<template>
  <el-card
    v-if="element"
    :body-style="{ padding: '1rem 0' }"
    style="margin: 1rem 1rem 1rem 1rem"
    shadow="never"
  >
    <VuePerfectScrollbar
      class="d-flex flex-column p-5"
      style="height: calc(100dvh - 11.7rem)"
    >
      <div class="d-flex profile-container">
        <el-form
          style="width: 35rem"
          :model="request"
          :rules="rules"
          ref="exportInvoice"
          autocomplete="off"
        >
          <div class="d-flex flex-column">
            <div class="profile-item">
              <div class="profile-title">
                <span>Customer type</span>
              </div>
              <div class="profile-content">
                <el-radio-group
                  :disabled="hadSend"
                  v-model="request.customerType"
                  @input="change"
                  style="margin-top: 0.9rem"
                >
                  <el-radio :label="customerTypeList.personal"
                    >Personal</el-radio
                  >
                  <el-radio :label="customerTypeList.business"
                    >Business</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div>
              <div class="profile-item">
                <div class="profile-title">
                  <span>Invoice receipt email</span>
                </div>
                <div class="profile-content">
                  <el-form-item prop="email">
                    <el-input
                      :disabled="hadSend"
                      v-model="request.email"
                      @input="change"
                      size="small"
                      placeholder="Email..."
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="profile-item">
                <div class="profile-title">
                  <span>{{
                    request.customerType === customerTypeList.personal
                      ? "Full name"
                      : "Company name"
                  }}</span>
                </div>
                <div class="profile-content">
                  <el-form-item prop="name">
                    <el-input
                      :disabled="hadSend"
                      v-model="request.name"
                      @input="change"
                      size="small"
                      :placeholder="`${
                        request.customerType === customerTypeList.personal
                          ? 'Your name...'
                          : 'Company name...'
                      }`"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="profile-item">
                <div class="profile-title">
                  <span>{{
                    request.customerType === customerTypeList.personal
                      ? "Address"
                      : "Company address"
                  }}</span>
                </div>
                <div class="profile-content">
                  <el-form-item prop="address">
                    <el-input
                      :disabled="hadSend"
                      v-model="request.address"
                      @input="change"
                      size="small"
                      :placeholder="`${
                        request.customerType === customerTypeList.personal
                          ? 'Address...'
                          : 'Company address...'
                      }`"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div
                class="profile-item"
                v-if="request.customerType === customerTypeList.business"
              >
                <div class="profile-title">
                  <span>Tax code</span>
                </div>
                <div class="profile-content">
                  <el-form-item prop="tax">
                    <el-input
                      :disabled="hadSend"
                      v-model="request.tax"
                      @input="change"
                      size="small"
                      placeholder="Tax code..."
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="profile-item">
                <div class="profile-title">
                  <span>Note</span>
                </div>
                <div class="profile-content">
                  <el-form-item prop="note">
                    <el-input
                      :disabled="hadSend"
                      type="textarea"
                      placeholder="Note ..."
                      v-model="request.note"
                      maxlength="500"
                      :rows="2"
                      show-word-limit
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div v-if="!hadSend" class="profile-item mt-4">
              <div class="profile-title"></div>
              <div class="profile-content">
                <el-button
                  @click="sendRequest('exportInvoice')"
                  size="small"
                  type="primary"
                  >Send request</el-button
                >
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div style="width: 35rem" class="mt-5 ml-5">
        <div v-if="hadSend" style="color: #ff9800; font-size: 0.95rem">
          <div>
            • Your invoice information has been received by us. We will process
            your request within 24 hours from the time of successful request
            submission.
          </div>
          <div class="mt-2">
            • If you have any questions please contact us invoice@irender.vn
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </el-card>
</template>

<script>
// CSS
import "@/assets/css/invoice.scss";

//Lib
import { mapState } from "vuex";

// Api
import api from "@/api/baseApi";

// Constant
import {
  SETTINGS_USER_API,
  SETTINGS_TRANSACTION_API,
} from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { regex } from "@/constant/config";

// Extend
import base from "@/scripts/base";

export default {
  extends: base,

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  props: {
    element: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      rules: {
        email: [
          {
            required: true,
            message: this.$lang.register.validationRequiredEmail,
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$lang.register.validationTypeEmail,
            trigger: ["blur", "change"],
          },
          {
            max: 50,
            message: this.$lang.register.validationMaxEmail,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: this.$lang.profile.validationRequiredFullName,
            trigger: "blur",
          },
          {
            max: 255,
            message: this.$lang.profile.validationMaxFullName,
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "Don't leave your address blank!",
            trigger: "blur",
          },
          {
            max: 500,
            message: this.$lang.profile.validationMaxAddress,
            trigger: ["blur", "change"],
          },
        ],
        tax: [
          {
            required: true,
            message: "Don't leave your Tax code blank!",
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$lang.profile.validationMaxAddress,
            trigger: ["blur", "change"],
          },
        ],
      },

      customerTypeList: {
        personal: 1,
        business: 2,
      },

      request: {},

      hadSend: false,
    };
  },

  watch: {
    element: function (newVal, oldVal) {
      if (newVal.exportInvoiceId !== null) {
        this.hadSend = true;
        this.request = {
          customerType: newVal.exportInvoiceCustomerType,
          name: newVal.exportInvoiceName,
          address: newVal.exportInvoiceAddress,
          email: newVal.exportInvoiceEmail,
          tax: newVal.exportInvoiceTax,
          note: newVal.exportInvoiceNote,
        };
      } else {
        this.hadSend = false;
        this.getData();
      }
    },
  },

  methods: {
    //#region Invoice and Billing change information
    change() {},
    //#endregion

    //#region Invoice billing ___ View
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api
        .baseRequest(SETTINGS_USER_API.INVOICE_BILLING_SETTINGS_VIEW, null)
        .then((res) => {
          let responseData = res.data;
          this.request = {
            customerType: responseData.customerType,
            name:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalName
                : responseData.businessName,
            address:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalAddress
                : responseData.businessAddress,
            email: this.user.email,
            tax:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalTaxCode
                : responseData.businessTaxCode,
            note: null,
          };
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch((error) => {
          this.processCatchApiRequest(error, "Request failed ...");
        });
    },
    //#endregion

    //#region Export invoice
    sendRequest(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.feedStatusLoading(API_CALL_STATUS.LOADING);
          setTimeout(() => {
            let data = {
              customerType: this.request.customerType,
              transactionCode: this.element.transactionId,
              name: this.request.name,
              address: this.request.address,
              email: this.request.email,
              tax: this.request.tax,
              note: this.request.note,

              deviceInformation: JSON.stringify(this.getInformationClient()),
            };
            api
              .baseRequest(
                SETTINGS_TRANSACTION_API.TRANSACTION_EXPORT_INVOICE,
                data
              )
              .then(() => {
                this.notificationSuccess(
                  "Success ... !",
                  `Your information have been successfully saved`
                );
                this.hadSend = true;
                this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
              })
              .catch((error) => {
                this.processCatchApiRequest(error, "Boot failed ...");
              });
          }, this.smoothTimeOut);
        } else {
          return false;
        }
      });
    },
    //#endregion
  },
};
</script>